<template>
  <div class="my-vacancies-list">
    <div v-if="error">
      <ErrorView
          :code="error.code"
          :title="error.message"
      />
    </div>

    <div v-if="pending" class="page__columns-inner container-inner">
      <div class="page__main-col">
        <BasePreloader/>
      </div>
    </div>

    <div v-else-if="vacancies.length">

      <div class="my-vacancies-list__inner">
        <MyVacancyCard v-for="item in vacancies"
                       :key="item.id"
                       :vacancy="item"
                       class="my-vacancies-list__item"
                       @reload="reload"
                       @show="$emit('show-vacancy')"
        />
      </div>
      <div class="my-vacancies-list__pagination-wrap">
        <Pagination v-if="pagesCount > 1"
                    :quantity="pagesCount"
                    :withGoTo="false"
                    class="my-vacancies-list__pagination"/>
      </div>

      <!---->

    </div>

    <div v-else-if="isBaseList"
         class="my-vacancies-list__empty">
      <picture class="my-vacancies-list__empty-bg">
        <!--              <source srcset="@/assets/img/empty-resume-base.svg" media="(max-width: 550px)">-->
        <img src="@/assets/img/empty-resume-base.svg" alt="bg">
      </picture>
      <h3 class="my-vacancies-list__empty-title">{{
          $tEmployerVacancies('Vacancies list is empty')
        }}</h3>
      <div class="my-vacancies-list__empty-text">
        {{ $tEmployerVacancies('To get started, create the first vacancy') }}
      </div>
      <div class="my-vacancies-list__empty-btn-wrap">
        <router-link-modified class="my-vacancies-list__empty-btn base-btn  base-btn--green"
                              :to="{name: 'account-new-vacancy'}">
          <BaseSvg name="ico-plus"
                   width="1.1rem"
                   height="1.1rem"/>
          <span>{{ $tEmployerVacancies('Create vacancy') }}</span>
        </router-link-modified>
      </div>
    </div>

    <div v-else>{{ $tEmployerVacancies('vacancies_not_found') }}</div>
  </div>
</template>

<script>
  import {http} from "../axios"
  import MyVacancyCard from "./MyVacancyCard";
  import Pagination from "./Pagination";
  import ErrorView from '@/components/ErrorView'
  import {CancelToken} from 'axios'
  import handleError from '@/helpers/handleError'

  export default {
    name: "MyVacanciesList",
    components: {
      MyVacancyCard,
      Pagination,
      ErrorView,
    },
    props: {
      apiQueryPath: {
        type: String,
        default: '/api/cabinet/vacancies',
      },
      isBaseList: Boolean,
      sort: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        error: null,
        timer: null,
        pending: false,
        vacancies: [],
        total: 0,
        perPage: 10,
        cancel: null,
        queryNamePage: 'page',
      }
    },
    computed: {
      page() {
        return this.$route.query[this.queryNamePage] || 1
      },
      pagesCount() {
        return Math.ceil(this.total / this.perPage) || 0
      },
      queryParams() {
        const params = {};
        const queryParamsNames = ['search_query', 'page'];

        if (this.sort) Object.assign(params, { order_by: this.sort })

        for (let name of queryParamsNames) {
          let value = this.$route.query[name]
          if (value) {
            params[name] = value
          }
        }

        params.limit = this.perPage

        return params
      }
    },
    mounted() {
      this.$store.dispatch('user/userPusher/createPusher');
      this.$store.dispatch('user/unSubscribeOnReceivedResumes');

      const { channel } = this.$store.state.user.userPusher;
      channel.bind('resume-count-notify', () => {
        setTimeout(() => this.reload(), 1000);
      });
    },
    methods: {
      load() {
        this.error = null
        this.pending = true

        http.get(this.apiQueryPath, {
              params: this.queryParams,
              cancelToken: new CancelToken((c) => this.cancel = c)
            }
        ).then(({data}) => {
          if (data.data.last_page < data.data.current_page) {
            let page = data.data.last_page || 1
            this.$router.push({query: {...this.$route.query, [this.queryNamePage]: page}})
          } else {
            this.parseVacancies(data.data)
          }
        }).catch((e) => {
          this.error = {
            code: e.response && e.response.status,
            message: handleError(e)
          }
        }).finally(() => {
          this.pending = false
        })
      },
      parseVacancies(data) {
        this.vacancies = data.data
        this.total = data.total
      },
      reload() {
        this.load()
      },

      subscriberOnUpdate() {
        this.$store.dispatch('user/userPusher/createPusher')
        this.unSubscribeOnUpdate()

        const channel = this.$store.state.user.userPusher.channel
        channel.bind('update-customer-vacancies-list', () => {
          this.load()
        })
      },
      unSubscribeOnUpdate() {
        const channel = this.$store.state.user.userPusher.channel
        if (!channel) return
        channel.unbind('update-customer-vacancies-list')
      },

      /* onSortInput(value) {
         this.$router.push({query: {...this.$route.query, order_by: value}})
       },
       getOptionTextSort(option) {
         return this.$tVacancies(option)
       }*/
    },
    created() {
      this.load()
      this.subscriberOnUpdate()
    },
    beforeDestroy() {
      this.$store.state.user.userPusher.channel?.unbind('resume-count-notify');
      this.unSubscribeOnUpdate()
    },
    watch: {
      $route() {
        this.load()
      }
    }
  }
</script>
